export const getDayOfMonthFormat = (): string => {
  switch (navigator.languages?.[0]) {
    case 'de':
    case 'de-DE':
      return 'd.';
    default:
      return 'd';
  }
};

export const getEventDateTimeFormat = (): string => `EEE ${getDayOfMonthFormat()} MMM yyyy, HH:mm`;
